import { gql } from 'apollo-boost';
import { FOLDER_CACHE_SAFE_FIELDS } from '../../fragments/folder/cache-safe-folder-fields';

export const COPY_PUBLISHED_FOLDER = gql`
    mutation copyPublishedFolder($data: CopyPublishedFolderInput!) {
        copyPublishedFolder(data: $data) {
            folder {
                ...FolderCacheSafeFields
            }
        }
    }
    ${FOLDER_CACHE_SAFE_FIELDS}
`;